export const IS_DEVELOPMENT = import.meta.env.VITE_ENV !== 'production';
